import type { GameRoomState } from "@presidents/game-engine";
import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useGameRoomStateChange } from "../context/GameRoomState";
import { useUser } from "../context/UserContext";
import stateChangeMessage from "../utils/state-change-message";

const Element = styled.div`
  font-size: 14px;
  line-height: 21px;
  color: #fff;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.8), 0 0 2px rgba(0, 0, 0, 0.8),
    0 0 4px rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 100%;
  left: 50%;
  margin-top: 8px;
  text-align: center;
`;
const inAnim = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -100%)
    }
`;
const Message = styled.div<{ idx: number }>`
  --idx: ${(props) => props.idx};

  padding: 2px 6px;
  animation: ${inAnim} 0.3s linear;
  transition: transform 0.3s linear, opacity 0.3s linear;
  position: absolute;
  top: 0;
  white-space: nowrap;
  transform: translate(-50%, calc(var(--idx) * 100%));
  z-index: 1;

  &:first-child {
    transform: translate(-50%, calc(var(--idx) * 100%)) scale(1.1);
  }
  &.exiting,
  &.exit {
    opacity: 0;
  }

  ::before {
    display: block;
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: radial-gradient(
      ellipse at center,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0) 80%
    );
    z-index: -1;
  }
`;

type Props = { gameRoomState: GameRoomState };
const GameMessages: React.FC<Props> = () => {
  const user = useUser();

  const now = Date.now();
  const [_, tick] = useState(() => now);

  // const stateRef = useRef(gameRoomState);

  const idRef = useRef(0);
  const [messageQueue, setMessagQueue] = useState<
    { id: number; deadline: number; message: string }[]
  >([]);

  useGameRoomStateChange((currRoomState, nextRoomState) => {
    if (!nextRoomState) {
      return;
    }
    const effectNow = Date.now();
    // const nextMessages = messageQueue.slice();
    const nextMessages = messageQueue.filter(
      (m) => m.deadline > effectNow + 1e3
    );
    const newMessageStrings = stateChangeMessage(
      user!,
      currRoomState,
      nextRoomState
    );
    if (newMessageStrings) {
      newMessageStrings.forEach((message) => {
        const newMessage = {
          id: ++idRef.current,
          deadline: effectNow + 15e3,
          message
        };
        nextMessages.unshift(newMessage);
      });
    }
    setMessagQueue(nextMessages);
  });

  useEffect(() => {
    let intervalId: number;
    if (messageQueue.length) {
      intervalId = window.setInterval(() => tick(Date.now()), 500);
    }
    return () => clearInterval(intervalId);
  }, [messageQueue.length]);

  // useEffect(() => {
  //   const effectNow = Date.now();
  //   // const nextMessages = messageQueue.slice();
  //   const nextMessages = messageQueue.filter(
  //     (m) => m.deadline > effectNow + 1e3
  //   );
  //   const newMessageStrings = stateChangeMessage(
  //     user!,
  //     stateRef.current,
  //     gameRoomState
  //   );
  //   if (newMessageStrings) {
  //     newMessageStrings.forEach((message) => {
  //       const newMessage = {
  //         id: ++idRef.current,
  //         deadline: effectNow + 15e3,
  //         message
  //       };
  //       nextMessages.unshift(newMessage);
  //     });
  //   }
  //   setMessagQueue(nextMessages);
  //   stateRef.current = gameRoomState;
  // }, [gameRoomState._id]);

  return (
    <Element>
      {messageQueue.map(({ id, deadline, message }, i) => {
        return (
          <Message
            key={id}
            className={
              now > deadline ? "exit" : now + 500 > deadline ? "exiting" : ""
            }
            idx={i}
          >
            {message}
          </Message>
        );
      })}
    </Element>
  );
};

export default GameMessages;
